var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M5 5h30v30H5z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.4s"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#58ACF4",
    d: "M35 5h30v30H35z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.3s"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#105EDD",
    d: "M65 5h30v30H65z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.2s"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#58ACF4",
    d: "M5 35h30v30H5z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.3s"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#105EDD",
    d: "M35 35h30v30H35z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.2s"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B3075",
    d: "M65 35h30v30H65z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.1s"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#105EDD",
    d: "M5 65h30v30H5z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.2s"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B3075",
    d: "M35 65h30v30H35z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "-0.1s"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M65 65h30v30H65z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    repeatCount: "indefinite",
    calcMode: "spline",
    dur: "1s",
    values: "1;1;0.2;1;1",
    keyTimes: "0;0.2;0.5;0.8;1",
    keySplines: "0.5 0.5 0.5 0.5;0 0.1 0.9 1;0.1 0 1 0.9;0.5 0.5 0.5 0.5",
    begin: "0s"
  }))));
}

export default SvgLoading;